import React from "react"
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";
import { FormSectionElements, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { dateComparisonList, fileTypeList, odsCallOutBoxs, UploadFileSizeLimit } from "../../entities/Constants";
import { InputTextarea } from "primereact/inputtextarea";
import { Editor } from "primereact/editor";
import { Checkbox } from "primereact/checkbox";
import { RadioButton } from "primereact/radiobutton";


interface Props {
    ele: FormSectionElements;
    dialogVisible: boolean;
    isEng: boolean;
    callback;

}

export class DialogForFileComponent extends React.Component<Props> {

    dateTypeFieldList = [];
    constructor(props: Props) {
        super(props);

        if (!this.props.ele.FileUpload?.AllowedForUploadFileTypeList) {
            this.props.ele.FileUpload = {...this.props.ele.FileUpload ?? {}, AllowedForUploadFileTypeList: []};
        }

    }

    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog header={this.props.isEng ? "Field Properties for " + this.props.ele.ENUTitle : "Field Properties for " + this.props.ele.FRATitle} footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
                    {this.otherPreviousDateFields()}
                </Dialog>
            </>
        );
        return html;
    }

    otherPreviousDateFields = () => {
        let htmlString = [];
        if (!this.props.ele.FileUpload) {
            this.props.ele.FileUpload = {AllowedForUploadFileTypeList: [], FileSizeLimit: UploadFileSizeLimit.size, SizeUnite: UploadFileSizeLimit.unite};
            this.props.callback();
        }
        

        htmlString.push(
            <div>
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '20px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"UpdateField" + this.props.ele.Sequence}>Update Binding Field</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"UpdateField" + this.props.ele.Sequence} value={this.props.ele.UpdateField} className="ontario-input"
                            onChange={(e) => { this.props.ele.UpdateField = e.target.value; this.props.callback() }} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Question Hint</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Editor style={{ height: 'auto' }} key={"Hint" + this.props.ele.Sequence}
                            value={this.props.isEng ? this.props.ele.Hint : this.props.ele.HintFR} onTextChange={(e) => {
                                if (this.props.isEng)
                                    this.props.ele.Hint = e.htmlValue;
                                else
                                    this.props.ele.HintFR = e.htmlValue;

                                this.props.callback();
                            }}></Editor></div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Empty Error Message</div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"EmptyErrorMessage" + this.props.ele.Sequence} className="ontario-input" 
                            value={this.props.isEng ? this.props.ele.EmptyErrorMessage : this.props.ele.EmptyErrorMessageFRA}
                            onChange={(e) => {
                                if (this.props.isEng)
                                    this.props.ele.EmptyErrorMessage = e.target.value;
                                else
                                    this.props.ele.EmptyErrorMessageFRA = e.target.value;
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Custom Error Message</div>
                    <div style={{ width: '60%' }}><InputText key={"ErrorMessage" + this.props.ele.Sequence} className="ontario-input" value={this.props.isEng ? this.props.ele.ErrorMessage : this.props.ele.ErrorMessageFRA}
                        onChange={(e) => {
                            if (this.props.isEng)
                                this.props.ele.ErrorMessage = e.target.value;
                            else
                                this.props.ele.ErrorMessageFRA = e.target.value;

                            this.props.callback();
                        }}></InputText></div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Tool Tip</div>
                    <div style={{ width: '60%' }}><InputText key={"TooltipENU" + this.props.ele.Sequence} className="ontario-input" value={this.props.isEng ? this.props.ele.TooltipENU : this.props.ele.TooltipFRA} onChange={(e) => {
                        if (this.props.isEng)
                            this.props.ele.TooltipENU = e.target.value;
                        else
                            this.props.ele.TooltipFRA = e.target.value;

                        this.props.callback();
                    }}></InputText></div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Hint Expansion Title</div>
                    <div style={{ width: '60%' }}><InputText key={"hintExpansionTitle" + this.props.ele.Sequence}
                        className="ontario-input" value={this.props.isEng ? this.props.ele.hintExpansionTitle : this.props.ele.hintExpansionTitleFRA}
                        onChange={(e) => {
                            if (this.props.isEng)
                                this.props.ele.hintExpansionTitle = e.target.value;
                            else {
                                this.props.ele.hintExpansionTitleFRA = e.target.value;
                            }
                            this.props.callback();
                        }}></InputText></div>
                </div>

                {/* Alert box options */}
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown key={"callOutBoxType" + this.props.ele.Sequence} showClear options={odsCallOutBoxs} optionLabel='label' optionValue='val' value={this.props.ele.callOutBoxType} onChange={(e) => {
                            if (this.props.isEng) {
                                this.props.ele.callOutBoxType = e.value;
                            } else {
                                this.props.ele.callOutBoxBodyFRA = e.value;
                            }
                            this.props.callback();
                        }}></Dropdown>
                    </div>
                </div>

                <div style={{ display: this.props.ele.callOutBoxType != null ? "flex" : "none", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box Title</div>
                    <div style={{ width: '60%' }}><InputText key={"callOutBoxTitle" + this.props.ele.Sequence} className="ontario-input"
                        value={this.props.isEng ? this.props.ele.callOutBoxTitle : this.props.ele.callOutBoxTitleFRA}
                        onChange={(e) => {
                            if (this.props.isEng)
                                this.props.ele.callOutBoxTitle = e.target.value;
                            else
                                this.props.ele.callOutBoxTitleFRA = e.target.value;
                            this.props.callback();
                        }}></InputText></div>
                </div>

                <div style={{ display: this.props.ele.callOutBoxType != null ? "flex" : "none", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box Body Message</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Editor className="ontario-input" value={this.props.isEng ? this.props.ele.callOutBoxBody : this.props.ele.callOutBoxBodyFRA}
                            onTextChange={(e) => {
                                if (this.props.isEng)
                                    this.props.ele.callOutBoxBody = e.htmlValue;
                                else
                                    this.props.ele.callOutBoxBodyFRA = e.htmlValue;
                                this.props.callback();
                            }}></Editor>
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Script</div>
                    <div style={{ width: '60%' }}>
                        <InputTextarea className="ontario-input" key={"Script" + this.props.ele.Sequence}
                            value={this.props.ele.Script} onChange={(e) => {
                                this.props.ele.Script = e.target.value;
                                this.props.callback();
                            }}></InputTextarea></div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Allowed file types</div>
                    <div style={{ width: '60%' }}>
                        {this.generateAllowedFileTypeHtml()}
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Preview file</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox inputId={`file-upload-preview-${this.props.ele.Id}`}  
                            name={`previewFile-${this.props.ele.Id}`}
                            value={this.props.ele.FileUpload?.PreviewFile}
                            checked={this.props.ele.FileUpload?.PreviewFile}
                            onChange={(e)=>{
                                this.props.ele.FileUpload = {...this.props.ele.FileUpload, PreviewFile: e.target.checked}
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>File description</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox inputId={`file-upload-description-${this.props.ele.Id}`}
                            name={`fileDescription-${this.props.ele.Id}`}
                            value={this.props.ele.FileUpload?.hasDescription}
                            checked={this.props.ele.FileUpload?.hasDescription}
                            onChange={(e)=>{
                                this.props.ele.FileUpload = {...this.props.ele.FileUpload, hasDescription: e.target.checked}
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Use legacy style</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox inputId={`file-upload-legacy-${this.props.ele.Id}`}
                            name={`legacy-style-${this.props.ele.Id}`}
                            value={this.props.ele.FileUpload?.LegacyStyle}
                            checked={this.props.ele.FileUpload?.LegacyStyle}
                            onChange={(e)=>{
                                this.props.ele.FileUpload = {...this.props.ele.FileUpload, LegacyStyle: e.target.checked}
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>File Size</div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"fielSize" + this.props.ele.Sequence}
                            className="ontario-input" 
                            value={this.props.ele.FileUpload?.FileSizeLimit?.toString()}
                            placeholder="20"
                            onChange={(e) => {
                                const value = Number(e.target.value);
                                if (!isNaN(value)) {
                                    this.props.ele.FileUpload={...this.props.ele.FileUpload ?? {AllowedForUploadFileTypeList: []}, FileSizeLimit: Number(e.target.value)};
                                    this.props.callback();
                                }
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>File size unite:</div>
                    <div style={{ width: '30%', display: 'flex'}}>
                        {/* @ts-ignore */}
                        <RadioButton inputId={`file-size-unit-mb-${this.props.ele.Id}`}
                            name={`file-size-${this.props.ele.Id}`}
                            value='MB'
                            checked={!this.props.ele.FileUpload?.SizeUnite || this.props.ele.FileUpload?.SizeUnite==='MB'}
                            onChange={(e)=>{
                                if (e.target.checked) {
                                    this.props.ele.FileUpload = {...this.props.ele.FileUpload, SizeUnite: 'MB'}
                                    this.props.callback();
                                }
                            }}
                        />
                        <label htmlFor={`file-size-unit-mb-${this.props.ele.Id}`} className="ontario-margin-left-8-!">MB</label>
                    </div>
                    <div style={{ width: '30%', display: 'flex'}}>
                        {/* @ts-ignore */}
                        <RadioButton inputId={`file-size-unit-gb-${this.props.ele.Id}`}
                            name={`file-size-${this.props.ele.Id}`}
                            value='GB'
                            checked={this.props.ele.FileUpload?.SizeUnite==='GB'}
                            onChange={(e)=>{
                                if (e.target.checked) {
                                    this.props.ele.FileUpload = {...this.props.ele.FileUpload, SizeUnite: 'GB'}
                                    this.props.callback();
                                }
                            }}
                        />
                        <label htmlFor={`file-size-unit-gb-${this.props.ele.Id}`} className="ontario-margin-left-8-!">GB</label>
                    </div>
                </div>
            </div>
        )

        return htmlString;
    }

    generateAllowedFileTypeHtml = () => {
        let checkboxHtml=[];
       
        fileTypeList.map((fileType) => {
            checkboxHtml.push( 
                <div key={fileType.label} className="flex align-items-center">
                    {/* @ts-ignore */}
                    <Checkbox inputId={fileType.label} name="fileType" value={fileType.label}
                        onChange={(e)=>{
                            if(e.checked){
                                this.props.ele.FileUpload.AllowedForUploadFileTypeList.push(fileType);
                            } else {
                                this.props.ele.FileUpload.AllowedForUploadFileTypeList = 
                                    this.props.ele.FileUpload.AllowedForUploadFileTypeList.filter(item => fileType.label!==item.label);
                            }
                            this.props.callback();
                        }}
                        checked={this.props.ele.FileUpload.AllowedForUploadFileTypeList.some((item) => fileType.label==item.label)} />
                    <label htmlFor={fileType.label}>{fileType.label}({fileType.val.map(val => (val.ext)).join(', ')})</label>
                </div>
            )
        });

        return checkboxHtml;
    }

    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
